import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { createFilterOptions } from "@mui/material/Autocomplete";
import { SelectChangeEvent } from "@mui/material/Select";
import { useApiUrl } from "@refinedev/core";
import { useAutocomplete } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";
import UserRole from "@warriortrading/warriortrading.hermes.common.feathers/enums/userRole";
import { memo, useEffect, useState } from "react";
import { dataProvider } from "rest-data-provider";
import { config } from "config";

interface ProductRoom {
  isOpen: boolean;
  id: string;
  handleClose: any;
  fetchRoomsData: any;
}

const AddProductRoom = memo(function AddProductRoom(props: ProductRoom) {
  const { autocompleteProps } = useAutocomplete({
    resource: "rooms",
    pagination: {
      pageSize: config().relationPageSize,
    },
    sorters: [
      {
        field: "name",
        order: "asc",
      },
    ],
  });
  const filterOptions = createFilterOptions({
    stringify: (option: any) => option.title,
  });
  const { register } = useForm();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    setOpen(props.isOpen);
  }, [props.isOpen]);

  const handleClose = (event: any, reason: any) => {
    if (reason === "escapeKeyDown" || reason === "backdropClick") return;
    props.handleClose();
  };

  const [value, setValue] = useState("3");
  const handleChange = (event: SelectChangeEvent) => {
    setValue(event.target.value as string);
  };
  const [roomId, setRoomId] = useState("");
  const hasRoom = (rows: []): boolean => {
    return rows.some((item: any) => {
      return item.roomId === roomId;
    });
  };

  const apiUrl = useApiUrl();
  const fetchData = (id: any) => {
    return dataProvider(apiUrl)
      .getList({
        resource: "prod-category-room-relations",
        filters: [
          {
            field: "categoryId",
            operator: "eq",
            value: id,
          },
        ],
      })
      .then((res) => {
        return res?.data;
      });
  };
  const saveRoom = async () => {
    if (!roomId) {
      window.alert("The room you added is blank, please add it again!");
      return;
    }
    const rows = (await fetchData(props.id)) as any;

    if (rows && rows.length !== 0) {
      if (hasRoom(rows)) {
        window.alert("The room you added already exists, please add it again!");
        return;
      }
    }
    await dataProvider(apiUrl).create({
      resource: "prod-category-room-relations",
      variables: {
        admin: "true",
        categoryId: props.id,
        role: value,
        roomId: roomId,
      },
    });
    props.handleClose();
    props?.fetchRoomsData(props?.id);
  };
  return (
    <div>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle id="responsive-dialog-title">ADD ROOM</DialogTitle>
        <DialogContent>
          <Autocomplete
            sx={{ width: 300 }}
            {...autocompleteProps}
            getOptionLabel={(item) => item.title}
            isOptionEqualToValue={(option, value) => {
              return (
                value === undefined ||
                option?.id?.toString() === (value?.id ?? value)?.toString()
              );
            }}
            onChange={(event: any, value) => {
              setRoomId(value?.id);
            }}
            filterOptions={filterOptions}
            renderInput={(params) => {
              return (
                <TextField
                  {...params}
                  label="title"
                  margin="normal"
                  variant="outlined"
                  required
                />
              );
            }}
          />
          <Select
            {...register("badgeId", {
              required: "This field is required",
            })}
            value={value}
            label="BadgeName"
            onChange={handleChange}
            sx={{ width: 300 }}
          >
            {Object.values(UserRole)[0].map((item: any) => {
              return (
                <MenuItem key={item.value} value={item.value}>
                  {item.name}
                </MenuItem>
              );
            })}
          </Select>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button onClick={saveRoom}>SAVE</Button>
          <Button color="error" onClick={props.handleClose}>
            CANCEL
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
});

export default AddProductRoom;
